export default {
  home: '首页',
  pleaseSelect: '请选择',
  toRight: '向右',
  toLeft: '向左',
  filterColumns: '筛选列',
  importExportUpdateSettings: '导入导出更新设置',
  searchForTheTaskTypeName: '搜索任务类型名称',
  taskTypeName: '任务类型名称',
  status: '状态',
  description: '描述',
  priority: '优先级',
  startTime: '开始时间',
  endTime: '结束时间',
  createTime: '创建时间',
  lastModifiedTime: '最后修改时间',
  triggerInterval: '触发间隔',
  operate: '操作',
  open: '开启',
  deactivate: '停用',
  createANewTaskType: '新建任务类型',
  editTheTaskType: '编辑任务类型',
  basicInformation: '基本信息',
  associationProperties: '关联属性',
  associativeTags: '关联位号',
  associateDocuments: '关联文档',
  namespace: '命名空间',
  category: '类别',
  shortDescription: '短描述',
  longDescription: '长描述',
  documentBrowsing: '文档浏览',
  associativeRelationships: '关联关系',
  changeHistory: '变更记录',
  changes: '变更项',
  beforeTheChange: '变更前',
  afterTheChange: '变更后',
  fileName: '文件名称',
  documentName: '文档名称',
  onlyOneFileCanBeUploadedAtATime: '一次只能上传一个文件',
  or: '或',
  clickUpload: '点击上传',
  pleaseSelectADirectoryType: '请选择目录类型',
  pleaseSelectTheObjectEncoding: '请选择对象编码',
  nodataPressEnterToQuery: '暂无数据（按Enter回车键查询）',
  pleaseSelectADocumentName: '请选择文档名称',
  identificationNamePrefixMatch: '标识名前缀匹配',
  tagCode: '对象编码',
  tagName: '对象名称',
  tagClassName: '对象分类名称',
  documentCode: '文档编码',
  identifier: '标识',
  addANewAssociation: '新增关联关系',
  editTheAssociation: '编辑关联关系',
  pleaseSelectAFileName: '请选择文件名称',
  pleaseEnterADistinguishedName: '请输入标识名',
  startDate: '开始日期',
  endDate: '结束日期',
  entityName: '实体名称',
  estimatedAmount: '预计采集数据量',
  realAmount: '实际采集数量',
  acquisitionTime: '更新时间',
  dailyReconciliation: '日对账',
  weeklyReconciliation: '周对账',
  monthlyReconciliation: '月对账',
  standardLibrary: '标准库',
  propertyField: '属性字段',
  addTo: '添加到',
  ruleName: '规则类别',
  ruleDescription: '规则描述',
  ruleContent: '规则内容',
  regularRegularity: '规则正则',
  runningStatus: '运行状态',
  frequencyOfExecution: '执行频次',
  lastRunTime: '上次运行时间',
  lastRunStatus: '上次运行状态',
  elapsedLastRunSeconds: '上次运行耗时(秒)',
  nextRunTime: '下次运行时间',
  detail: '详情',
  back: '返回',
  disassociate: '解除关联',
  Whethertodisassociatethedata: '是否解除关联的数据',
  metaDataName: '关联元数据名称',
  metaDataCode: '关联元数据代码',
  dataDesensitizationRule: '数据脱敏规则',
  referenceData: '参考数据',
  labelName: '标签代码',
  labelCode: '标签名称',
  refresh: '刷新',
  reset: '重置',
  tableCode: '表代码',
  entityName: '实体名称',
  tableName: '表名称',
  pleaseSelectABusinessCategory: '请选择业务分类',
}
